import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[_c('flight-info-departure',{attrs:{"value":_vm.value}})],[_c('flight-info-arrival',{attrs:{"value":_vm.value,"showCTOT":false}})],_c(VDivider),_c('flight-info-ac',{attrs:{"value":_vm.value}}),_c(VDivider),(_vm.value.pax)?[_c('flight-info-pax',{attrs:{"value":_vm.value}}),_c(VDivider)]:_vm._e(),_c('flight-info-state',{attrs:{"value":_vm.value}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }